import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { BookOpenIcon, GiftIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function OfferBlock() {
  return <section id="offer" className="py-10 sm:py-14 relative" data-id="element-263">
      <div className="absolute inset-0 bg-gradient-radial from-gold/10 to-transparent opacity-50 blur-3xl -z-10" data-id="element-264" />

      <div className="mx-auto max-w-5xl px-6 lg:px-8" data-id="element-265">
        <div className="bg-navy-light border border-gold/20 rounded-3xl p-8 sm:p-12 shadow-[0_0_50px_rgba(212,168,83,0.1)] relative overflow-hidden" data-id="element-266">
          {/* Decorative glow */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-md h-px bg-gradient-to-r from-transparent via-gold to-transparent opacity-50" data-id="element-267" />

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-268">
            <FadeIn direction="right" data-id="element-269">
              <div className="relative mx-auto w-full max-w-sm" data-id="element-270">
                {/* Bonus 2 - back left */}
                <img src="https://cdn.magicpatterns.com/uploads/iPxM7BKGnAgvnQhcJK3CeK/Bono_2.png" alt="Rutina Nocturna Express" className="absolute -left-4 top-8 w-28 sm:w-32 rounded-lg shadow-xl ring-1 ring-white/10 opacity-60 -rotate-6 z-0" data-id="element-271" />
                {/* Bonus 1 - back right */}
                <img src="https://cdn.magicpatterns.com/uploads/cpHkiYZJNrzRtrwhfDS1gK/Bono_1.png" alt="Kit de Emergencia 3 AM" className="absolute -right-4 top-8 w-28 sm:w-32 rounded-lg shadow-xl ring-1 ring-white/10 opacity-60 rotate-6 z-0" data-id="element-272" />
                {/* Main ebook - front center */}
                <img src="https://cdn.magicpatterns.com/uploads/3wNJ8cPmdAYXx6vMg6UdiJ/Mockup.png" alt="Kit Gato Zen" className="relative z-10 w-full rounded-xl shadow-2xl ring-1 ring-white/10" data-id="element-273" />
                {/* Bonus thumbnails with names */}
                <div className="relative z-10 mt-6 flex items-center justify-center gap-4" data-id="element-274">
                  <div className="flex items-center gap-3 bg-navy/80 border border-white/10 rounded-xl px-3 py-2" data-id="element-275">
                    <img src="https://cdn.magicpatterns.com/uploads/cpHkiYZJNrzRtrwhfDS1gK/Bono_1.png" alt="Kit de Emergencia 3 AM" className="w-10 h-10 rounded-md object-cover ring-1 ring-gold/30" data-id="element-276" />
                    <div className="text-left" data-id="element-277">
                      <div className="flex items-center gap-1" data-id="element-278">
                        <GiftIcon className="h-3 w-3 text-gold" data-id="element-279" />
                        <span className="text-[10px] uppercase tracking-wider text-gold font-semibold" data-id="element-280">
                          Bono
                        </span>
                      </div>
                      <p className="text-xs text-slate-300 font-medium leading-tight" data-id="element-281">
                        Kit de Emergencia 3 AM
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3 bg-navy/80 border border-white/10 rounded-xl px-3 py-2" data-id="element-282">
                    <img src="https://cdn.magicpatterns.com/uploads/iPxM7BKGnAgvnQhcJK3CeK/Bono_2.png" alt="Rutina Nocturna Express" className="w-10 h-10 rounded-md object-cover ring-1 ring-gold/30" data-id="element-283" />
                    <div className="text-left" data-id="element-284">
                      <div className="flex items-center gap-1" data-id="element-285">
                        <GiftIcon className="h-3 w-3 text-gold" data-id="element-286" />
                        <span className="text-[10px] uppercase tracking-wider text-gold font-semibold" data-id="element-287">
                          Bono
                        </span>
                      </div>
                      <p className="text-xs text-slate-300 font-medium leading-tight" data-id="element-288">
                        Rutina Nocturna Express
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </FadeIn>

            <FadeIn direction="left" className="text-center lg:text-left" data-id="element-289">
              <div className="inline-flex items-center gap-2 rounded-full bg-gold/10 px-4 py-2 text-sm font-medium text-gold ring-1 ring-inset ring-gold/20 mb-6" data-id="element-290">
                <BookOpenIcon className="h-4 w-4" data-id="element-291" />
                <span data-id="element-292">Acceso Inmediato</span>
              </div>

              <h2 className="text-3xl sm:text-4xl font-bold mb-6" data-id="element-293">
                Recuperá tu descanso hoy mismo
              </h2>

              <p className="text-lg text-slate-400 font-sans mb-8" data-id="element-294">
                Por una fracción de lo que cuesta una consulta con un
                conductista felino.
              </p>

              <div className="mb-8" data-id="element-295">
                <p className="text-sm text-slate-500 font-sans uppercase tracking-wider mb-2" data-id="element-296">
                  Precio Único
                </p>
                <div className="flex items-baseline justify-center lg:justify-start gap-2" data-id="element-297">
                  <span className="text-5xl font-bold text-gold-light" data-id="element-298">
                    $9.499
                  </span>
                  <span className="text-xl text-slate-400 font-sans" data-id="element-299">ARS</span>
                </div>
              </div>

              <Button href="https://amigospeludosarg.shop/cart/49098154606834:1" fullWidth className="mb-4 text-xl py-5" onClick={() => trackAddToCart()} data-id="element-300">
                ¡QUIERO VOLVER A DORMIR!
              </Button>

              <p className="text-sm text-slate-400 font-sans text-center" data-id="element-301">
                Comprá ahora y recibí el protocolo en tu email al instante.
              </p>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}